import React from 'react'
import {IconButton, Tooltip} from '@mui/material'
import {NEUTRAL_SCALE, SEMANTIC} from 'src/theme-new/tokens'

// Shared round, icon-only button of the secondary-assumption flows: a soft tinted circle with the
// color on the glyph only. Used small in the list's row actions (QuickAnswerButtonsNew) and large
// for the "Hai assunto la terapia?" choice (AssumptionTakenChoiceNew), so both read as one set.
// `selected` fills the circle solid (white glyph) to make a previous choice obvious at a glance.

export type RoundActionTone = 'deny' | 'confirm' | 'neutral'

const TONES: Record<RoundActionTone, {color: string, background: string, hover: string}> = {
  deny: {color: SEMANTIC.error.main, background: SEMANTIC.error.light, hover: SEMANTIC.error.border},
  confirm: {color: SEMANTIC.success.main, background: SEMANTIC.success.light, hover: SEMANTIC.success.border},
  neutral: {color: NEUTRAL_SCALE[700], background: NEUTRAL_SCALE[100], hover: NEUTRAL_SCALE[200]},
}

export function getRoundActionColor(tone: RoundActionTone): string {
  return TONES[tone].color
}

interface RoundActionButtonNewProps {
  tone: RoundActionTone
  label: string
  onClick: () => void
  disabled?: boolean
  selected?: boolean
  size?: number
  children: React.ReactNode
}

export default function RoundActionButtonNew({
  tone,
  label,
  onClick,
  disabled,
  selected,
  size = 32,
  children
}: RoundActionButtonNewProps): JSX.Element {
  const {color, background, hover} = TONES[tone]
  const glyphColor = selected ? '#fff' : color
  const fillColor = selected ? color : background

  return (
    <Tooltip title={label}>
      {/* span keeps the tooltip working while the button is disabled */}
      <span style={{display: 'inline-flex'}}>
        <IconButton
          onClick={onClick}
          disabled={disabled}
          aria-label={label}
          aria-pressed={selected}
          sx={{
            width: size,
            height: size,
            color: glyphColor,
            backgroundColor: fillColor,
            transition: 'background-color 150ms ease, transform 150ms ease',
            '& .MuiSvgIcon-root': {fontSize: Math.round(size * 0.56)},
            '&:hover': {backgroundColor: selected ? color : hover, transform: 'scale(1.06)'},
            '&.Mui-disabled': {color: glyphColor, backgroundColor: fillColor, opacity: 0.5},
          }}
        >
          {children}
        </IconButton>
      </span>
    </Tooltip>
  )
}
